export const REQUESTS_FEED_BASE_API_URL = '/requests_feed';
export const REQUESTS_FEED_SLICE_NAME = 'requestsFeed';
